export default __webpack_public_path__ + "static/media/FSB_logo.4715e0a1.png";